import HttpBaseService from '@/services/http/HttpBaseService'

class NewsApiService extends HttpBaseService {

  index () {
    return this.executeRequest('/api/content/news', 'GET')
  }

  show (identifier) {
    return this.executeRequest(`/api/content/news/${identifier}`, 'GET')
  }
}

export default new NewsApiService()
